import React, { useState } from "react";
import Login from "../login";

import Input from "../../components/input";
import ErrorMessage from "../../components/errorMessage";
import CircularProgress from '@material-ui/core/CircularProgress';
import {useForgotPasswordMutation} from "../../services/accountsApi";

const ForgotPassword = ({ show, handleClose, handleShow }) => {
  const [initForgotPassword, {isLoading: forgotPasswordIsLoading}] = useForgotPasswordMutation();

  const [loader, setLoader] = useState(false)
  const [email, setEmail] = useState({
    value: "",
    error: null,
  });
  const [send, setSend] = useState(false);

  const submit = (e) => {
    setLoader(true)
    e.preventDefault();
    initForgotPassword({
      email: email.value,
    })
    .unwrap()
    .then((r) => {
      setLoader(false)
      setSend(true)
    });
  };
  return (
    <div className="">

      <Login handleClose={handleClose} show={show} />

      <div className="row-modal-2" style={{ margin: '8em 0 0 0' }}>
        {send ? (
          <ErrorMessage
            message="If an account matching that email address is found,
instructions to reset your account password will arrive
 in your mailbox shortly. "
            buttonText="Continue"
            link="/"
            button="true"
          />
        ) : (
          <div className="row-modal-2" >
            <div className="reset-password-card" style={{ margin: '0' }}>
              <h3 className="fadeIn first title">Reset Password</h3>

              <form onSubmit={submit} className="formLogin">
                <Input
                  label="Email"
                  state={email}
                  setState={setEmail}
                  name={email}
                  signup={true}
                />
                <div >

                  {!loader ? <button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className="orange-button"
                  >
                    Reset Password
                  </button>
                    :
                    <CircularProgress style={{ color: "#F29B1B" }} />
                  }

                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
